import BaseService from './baseService'; 

export class SensorService extends BaseService {
    constructor(){
        const baseUrl = "/Sensors";
        //console.log("SensorService Constructor called ..! parameter baseUrl = " + baseUrl);
        super(baseUrl);
    }  
} 